import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, Typography, Container, Stack, Skeleton } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import AppButton from '../../../components/ui/AppButton';
import { CouponStatus } from '../../../constants/coupon';

const bulletPoints = [
  'กรุณากดรับสิทธิ์ผ่าน Application LineOA: @CaltexStarcard พร้อมแสดง Barcode ส่วนลดในโทรศัพท์มือถือของท่านแก่พนักงาน ก่อนรับสิทธิ์ส่วนลด',
  'คูปองส่วนลดนี้ไม่สามารถใช้ร่วมกับรายการส่งเสริมการขาย หรือคูปองส่วนลดอื่นๆ ที่ร่วมรายการได้ ใบเสร็จรับเงินหลังหักส่วนลด สามารถร่วมรายการได้อีกตามกติกาที่กำหนด',
  'หลังจากลูกค้ายืนยันการใช้โค้ดแล้ว ไม่สามารถนำโค้ดนั้นๆ กลับมาใช้ซ้ำได้',
  'จำกัด 500 สิทธิ์ / จำนวน 2 สิทธิ์ / บริษัท / ตลอดรายการ',
  'โค้ดไม่สามารถยกเลิก โอน เปลี่ยน คืนเงิน หรือทอนเป็นเงินสดได้',
  'ไม่สามารถเปลี่ยนหรือทอนเป็นเงินสดได้ เมื่อใช้ไม่เต็มมูลค่า กรณีคืนสินค้าหลังจากหมดเขตการใช้คูปองไม่สามารถรับส่วนลดที่เกิดจากการคืนสินค้าได้',
  "ยกเว้นสินค้ากลุ่มแผ่นไม้ และแผ่นยิบซั่ม (S_Dept101), กระเบื้องและแผ่นหลังคา (Class10801), ปูนซีเมนต์ (S_Dept109), โครงฝ้าและผนัง (Class_11002), อิฐต่างๆ (S_Dept111), นั่งร้านและอุปกรณ์ (S_Class01120103), เหล็ก (S_Dept113), สินค้าท่อ PVC (Sub_class01140101-01140103), สายไฟ (Sub_Class02020601-02), ลวดเชื่อม สินค้าเครื่องดื่ม, กลุ่มน้ำยาทำความสะอาด, ยากำจัดแมลง, น้ำยารีดผ้าเรียบ-ปรับผ้านุ่ม, กระดาษชำระ (Dept800), สินค้าเครื่องใช้ไฟฟ้า (S_dept 408, 409, 410), กระเบื้องแกรนิตโต แบรนด์ KASSA รหัสสินค้า 60266736, 60271257, 60316247, 60318848 สินค้าสี แบรนด์ทีโอเอ รุ่น Supersheild / 4Season / Supermetex / Mandarin Duck / Homecote / Shield, สินค้าบาร์ E แผนกครัว, สินค้ากระดาษ A3 A4, สินค้าแผนกประตู, สินค้าปั๊มน้ำ แบรนด์ MITSUBISHI, MITSUBISHI ELECTRIC และ HITACHI, สินค้าแบรนด์ KASSA HOTEL, X'MAS TREE and stand, สินค้ากรอบรูป, สินค้าราคาลงท้ายด้วยเลข 1 และ 4, สินค้าดาวดำใน Brochure, สินค้าราคาโครงการ, และค่าบริการ VFIX",
  'กรณีมีการเปลี่ยนหรือคืนสินค้า ไม่สามารถใช้ส่วนลดได้อีก',
  'สามารถกดรับสิทธิ์ และใช้ส่วนลดได้ที่ ไทวัสดุ และ บีเอ็นบี โฮม ทุกสาขา ระหว่างวันที่ 1 พฤษภาคม 2569 - 31 ธันวาคม 2569 เท่านั้น',
  'ขอสงวนสิทธิ์ปฏิเสธการใช้งานการแสดงรหัสโค้ดส่วนลด การแสดงรหัส QR Code จากการถ่ายภาพ หรือการแคปเจอร์หน้าจอโทรศัพท์มือถือ อุปกรณ์อิเล็กทรอนิกส์ชนิดอื่นใด',
  'ไทวัสดุ และ บีเอ็นบี โฮม ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไข โดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
  'บริษัท สตาร์ ฟูเอลส์ มาร์เก็ตติ้ง จำกัด (SFL) ไม่รับผิดชอบในกรณี ที่คูปองหมดอายุหรือไม่สามารถใช้งานได้อันเนื่องมาจากไม่เป็นไปตามเงื่อนไข หรือมีการกดใช้งานคูปองแล้ว โดยการตัดสินจาก SFL ถือเป็นที่สิ้นสุด',
  'SFL ไม่รับผิดชอบต่อความเสียหาย และ/หรือ เหตุอื่นใดอันเกิดจากการ แจกคูปองที่ได้รับจากรายการนี้ ในส่วนที่ SFL ไม่มีส่วนร่วมหรือ เกี่ยวข้องหรือเป็นสาเหตุ',
  'การใช้งานคูปองและข้อกำหนดและเงื่อนไขในการใช้คูปองให้เป็นไปตาม ที่ให้จำหน่ายสินค้าและบริการเป็นผู้กำหนด หากมีข้อขัดข้องในการใช้คูปอง หรือต้องการสอบถามรายละเอียดเพิ่มเติมเกี่ยวกับการใช้คูปองหรือข้อกำหนดและเงื่อนไขการใช้คูปอง โปรดติดต่อผู้จำหน่ายสินค้าและบริการ',
  'ในกรณีที่มีปัญหาการกดรับคูปองผ่าน LineOA: @CaltexStarcard  หรือต้องการสอบถามรายละเอียดเพิ่มเติมเกี่ยวกับการกดรับคูปองผ่าน LineOA: @CaltexStarcard โปรดติดต่อทางช่องแชท LineOA: @CaltexStarcard',
  'SFL ถือว่าลูกค้าทุกรายที่เข้าร่วมรายการระหว่างระยะเวลาการใช้คูปองส่วนลดนี้ ได้ตกลงยอมรับข้อกำหนดตามกติกา และเงื่อนไขของการรับสิทธิพิเศษแล้วทุกประการ',
];

const CouponDetailTab = ({ data, isPending, onUseCoupon }) => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 2, pb: 12 }}>
      {/* Back Button */}
      <Box sx={{ mb: 1.5 }}>
        <Link to={'/my-coupon'}>
          <AppButton
            variant="neutral"
            startIcon={<ArrowBackIosIcon />}
            sx={{ gap: 0, py: 0.5, px: 2 }}
          >
            กลับ
          </AppButton>
        </Link>
      </Box>

      {/* Coupon Image */}
      {isPending && (
        <Box>
          <Skeleton
            variant="rounded"
            animation="wave"
            width="100%"
            height={180}
            sx={{ maxWidth: 400, mx: 'auto', borderRadius: '10px', backgroundColor: '#f7f7f7' }}
          />
        </Box>
      )}
      {!isPending && (
        <Box
          component={'img'}
          src={data?.reward_id?.image[0]}
          alt="coupon"
          sx={{
            display: 'block',
            width: 'auto',
            maxHeight: 175,
            objectFit: 'cover',
            mx: 'auto',
            mb: 2,
            borderRadius: '10px',
          }}
        />
      )}

      {/* Details Section */}
      <Box
        sx={{
          py: 2,
          mb: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '1.5rem',
            color: '#333',
            lineHeight: 1,
            mb: 1.25,
          }}
        >
          รายละเอียดการใช้คูปอง
        </Typography>
        <Stack spacing={0.75}>
          {bulletPoints.map((point, idx) => (
            <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <FiberManualRecordIcon
                sx={{
                  fontSize: '0.5rem',
                  color: '#333',
                  mt: 0.5,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: '1rem',
                  fontWeight: 300,
                  color: '#333',
                  lineHeight: 1,
                }}
              >
                {point}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>

      {/* Timer Warning Card */}
      <Box
        sx={{
          background: '#005972',
          borderRadius: '16px',
          py: {
            xs: 2,
            sm: 2,
          },
          px: {
            xs: 1,
            sm: 2,
          },
          boxShadow: '0 4px 5px rgba(255,255,255,0.15)',
          textAlign: 'center',
        }}
      >
        {data?.status.toLowerCase() !== CouponStatus.WAITING && !isPending && (
          <Stack
            direction="row"
            gap={{ xs: 4 }}
            justifyContent="center"
            sx={{ mb: 2, maxWidth: { sm: 400 }, mx: 'auto' }}
          >
            {/* Save for later button */}
            <AppButton
              variant="neutral"
              onClick={() => navigate(-1)}
              sx={{
                width: '50%',
                fontSize: { xs: '1.125rem' },
                py: 1,
                px: 0.5,
                borderRadius: '30px',
                fontWeight: 500,
              }}
            >
              เก็บไว้ใช้คราวหน้า
            </AppButton>

            {/* Use now button */}
            <AppButton
              variant="dangerStrong"
              onClick={onUseCoupon}
              sx={{
                width: '50%',
                fontSize: { xs: '1.125rem' },
                py: 1,
                px: 0.5,
                borderRadius: '30px',
                fontWeight: 600,
              }}
            >
              ใช้คูปองทันที
            </AppButton>
          </Stack>
        )}
        <Typography
          sx={{
            fontSize: {
              xs: '1.125rem',
              sm: '1.25rem',
            },
            fontWeight: 500,
            color: 'white',
            lineHeight: 1,
          }}
        >
          เมื่อคุณกด “ใช้คูปองทันที”
          <br />
          คูปองจะเริ่มนับถอยหลัง คุณมีเวลาใช้งานภายใน 30 นาทีเท่านั้น
        </Typography>
      </Box>
    </Container>
  );
};

export default CouponDetailTab;
